<template>
  <!-- 导入文件弹窗 -->
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.batchImport')"
    width="400px"
    :close-on-click-modal="false"
    append-to-body
  >
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form label-width="110px" label-position="left">
        <el-form-item :label="$t('Partners.firstPlease')">
          <el-button type="primary" @click="downLoadTemplate">{{ $t('SeaExport.TemplateDownload') }}</el-button>
        </el-form-item>
        <el-form-item :label="$t('Partners.selectImportFile')">
          <el-upload
            v-if="innerVisible"
            ref="upload"
            :limit="1"
            class="upload-demo"
            :action="action"
            :auto-upload="false"
            accept=".xls,.xlsx"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            :on-error="uploadError"
          >
            <el-button slot="trigger" size="small" type="primary">{{ $t('SeaExport.UploadFile') }}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="">
          <label>{{ $t('Partners.fileSizeCannotExceed20m') }}</label>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="submitUpload">{{ $t('Partners.startImport') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
    <!-- 用于打开新页面，并以post方式提交 -->
    <form ref="form" :action="url" target="_blank" method="post" style="display:none">
      <input v-for="(item,index) in formEntries" :key="index" :name="item.name" :value="item.value">
    </form>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import URL from '@/api/urlTranslator'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { getToken } from '@/utils/auth'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'ImportSupplyChain',
  components: { cargoAdvanceSelect },
  props: {
    companyUuid: { type: String, required: true },
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: false,
      exportResult: '',
      url: '',
      formEntries: []
    }
  },
  computed: {
    action() {
      return URL.partner.saveExcelFileForPartnerFactory + '?sessionId=' + this.$store.getters.token + '&companyUuid=' + this.companyUuid + '&branchId=' + this.$store.getters.currentOfficeId
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    downLoadTemplate() {
      ExportUtils.downloadTemplateFile('ImportSupplyChainTemplate.xls', 'partner')
    },
    submitUpload() {
      this.$refs.upload.submit()
    },
    beforeUpload(file) {
      this.loading = getLoading4Cxt(this)
      return true
    },
    async uploadSuccess(response, file, fileList) {
      this.loading.close()
      if (response && response.data) {
        const data = response.data
        this.exportResult = data.errorContent || ''
        if (data.isSuccess) {
          this.$message.success(this.$t('Message.ImportSuccessful1'))
          this.$emit('refresh')
          this.innerVisible = false
        } else {
          this.$message.success(data.message)
          await this.$confirm(data.message, this.$t('FileHistory.Tips'), { closeOnClickModal: false })
          this.url = URL.partner.exportExcelResult + '?sessionId=' + getToken() + '&fileName=ImportSupplyChainResult.xls&folderName=partner'
          this.formEntries = [
            { name: 'sessionId', value: getToken() },
            { name: 'fileSubPath', value: 'partner' },
            { name: 'template', value: 'ImportSupplyChainTemplate.xls' },
            { name: 'content', value: this.exportResult },
            { name: 'fileName', value: 'ImportSupplyChainResult.xls' }
          ]
          this.$nextTick(() => {
            this.$refs.form.submit()
          })
          this.innerVisible = false
        }
      } else {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    uploadError() {
      this.loading.close()
      this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
    }
  }
}
</script>

<style>
</style>
